import React from 'react';


export default function DocSection(props) {

    return (

        <section id={props.id} className="mb-8">
            <h1 className="font-bold text-3xl mb-2 text-gray-800">{props.text}</h1>
            <p>
                {props.children}
            </p>
        </section>

    )

}